import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import { PLANS } from '../apiUrls';
import organizationFields from '@/app/modules/organizations/fields/organizationFields';

/**
 * @param {Object} items
 * @param {string} responseData.items[].legalName
 * @param {string} responseData.items[].registrationNumber
 * @returns Mapped data object
 */
function mapResponseData(items) {
    const data = {};
    const mappedItems = items.map(item => ({
        [organizationFields.UUID.key]: item[organizationFields.UUID.key],
        [organizationFields.LEGAL_NAME.key]: item[organizationFields.LEGAL_NAME.key],
        [organizationFields.REGISTRATION_NUMBER.key]: item[organizationFields.REGISTRATION_NUMBER.key]
    }));

    data.items = mappedItems;
    return data;
}

const queryGetAllowedClients = ({ query, organizationId, planId }, enabled) => {
    return {
        queryKey: [PLANS.COLLECTION_PLAN_ALLOWED_CLIENTS.queryKey, query, organizationId, planId],
        queryFn: async () => {
            const response = await client
                .get(buildUrl(replaceParameters(PLANS.COLLECTION_PLAN_ALLOWED_CLIENTS.url, { organizationId: organizationId, planId: planId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetAllowedClients;